import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../contexts/AdminAuthContext';
import client from '../api/client';

export default function AdminDashboard() {
  const { admin, logout } = useAdminAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    if (!admin) { navigate('/admin/login'); return; }
    client.get('/admin/stats').then(res => setStats(res.data)).catch(() => {});
  }, [admin, navigate]);

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  if (!admin) return null;

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Admin Dashboard</h1>
        <button onClick={handleLogout} className="btn-secondary">Logout</button>
      </div>

      {stats && (
        <div className="stats-grid">
          <div className="stat-card">
            <h3>{stats.total_voters}</h3>
            <p>Total Voters</p>
          </div>
          <div className="stat-card">
            <h3>{stats.votes_cast}</h3>
            <p>Votes Cast</p>
          </div>
          <div className="stat-card">
            <h3>{stats.election_status?.toUpperCase()}</h3>
            <p>Election Status</p>
          </div>
        </div>
      )}

      <div className="nav-grid">
        <Link to="/admin/candidates" className="nav-card">
          <h3>Candidates</h3>
          <p>Manage election candidates</p>
        </Link>
        <Link to="/admin/parties" className="nav-card">
          <h3>Parties</h3>
          <p>Manage political parties</p>
        </Link>
        <Link to="/admin/voters" className="nav-card">
          <h3>Voters</h3>
          <p>Manage registered voters</p>
        </Link>
        <Link to="/admin/election" className="nav-card">
          <h3>Election</h3>
          <p>Open/close election, audit log</p>
        </Link>
      </div>
    </div>
  );
}
